import { render, staticRenderFns } from "./untreated.vue?vue&type=template&id=3fbc9c6a"
import script from "./untreated.vue?vue&type=script&lang=js"
export * from "./untreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports